import { Form, FormProps } from "@/components/form";
import { z } from "zod/v4";

export const organizacionFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    numDocumento: z.string().nonempty("Este campo es requerido"),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string(),
})

export default function OrganizacionForm({
    form,
    ...props
}: FormProps<z.input<typeof organizacionFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.TextField name="nombre" label="Nombre" />
        <Form.TextField name="numDocumento" label="N° Documento" />
        <Form.EmailField name="email" label="Email" />
        <Form.TextField name="telefono" label="Teléfono" />
        <Form.TextField name="direccion" label="Dirección" />
        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}